export default {
    name: 'Drink',
    dimensions: { width: 17, height: 41 },
    content: `
    <g clip-path="url(#clip0_12_1687)">
    <path d="M8.19439 25.033C6.38439 25.093 4.68439 24.353 3.47439 22.963C2.47439 21.833 2.00439 20.333 2.00439 18.823V9.03296H13.0044C13.5544 9.03296 14.0044 9.48296 14.0044 10.033V18.743C14.0044 22.113 11.3944 24.933 8.19439 25.033ZM2.00439 2.03296H13.0044C13.5544 2.03296 14.0044 2.48296 14.0044 3.03296V7.03296H3.00439C2.45439 7.03296 2.00439 6.58296 2.00439 6.03296V2.03296ZM14.0044 0.032959H2.00439C0.904395 0.032959 0.00439453 0.932959 0.00439453 2.03296V18.813C0.00439453 20.633 0.534395 22.453 1.64439 23.893C3.00439 25.643 4.91439 26.703 7.00439 26.963V38.033H1.00439C0.454395 38.033 0.00439453 38.483 0.00439453 39.033C0.00439453 39.583 0.454395 40.033 1.00439 40.033H15.0044C15.5544 40.033 16.0044 39.583 16.0044 39.033C16.0044 38.483 15.5544 38.033 15.0044 38.033H9.00439V26.963C12.9244 26.453 16.0044 22.913 16.0044 18.733V2.03296C16.0044 0.932959 15.1044 0.032959 14.0044 0.032959Z" fill="currentColor"/>
    </g>
    <defs>
    <clipPath id="clip0_12_1687">
    <rect width="16" height="40" fill="currentColor" transform="translate(0.00439453 0.032959)"/>
    </clipPath>
    </defs>
  `
};
